/**
 * Gate a URL before using it as an anchor `href`.
 *
 * Any URL that originates from user input or a third-party API (e.g. a
 * Linear/Jira/GitHub ticket URL stored unvalidated) can carry a
 * `javascript:` or `data:` scheme that executes on click. Allow only
 * http(s); anything else — or an unparseable/empty value — yields
 * `undefined` so the anchor renders inert.
 *
 * Uses the URL parser rather than a regex so scheme normalization
 * (lowercasing, control-char rejection) is delegated to the platform,
 * closing the usual regex-bypass tricks.
 */
export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:' ? url : undefined;
  } catch {
    return undefined;
  }
}
